export const Paths = {
  home: "/",
  login: "/login",
  cars: "/cars",
  car: "/cars/:id",
  users: "/users",
  user: "/users/:id",
  messages: "/messages",
  reports: "/reports",
  staff: "/staff",
  createStaff: "/staff/create",
  oneStaff: "/staff/:id",
  clicks: "/clicks",
  money: "/money",
  carRequest: "/carRequest",
  spareParts: "/spare-parts",
  shortVideos: "/short-videos",
  notifications: "/notifications",
  appUpdate: "/app-update",
  dealerMarketplace: "/dealer-marketplace",
  quickCapture: "/quick-capture",
  carImport: "/car-import",
  valuations: "/valuations",
  distribution: "/distribution",
  dealerLogin: "/login",
  dealerInventory: "/inventory",
  dealerDealPost: "/deals/new",
  legacyDealerLogin: "/dealer/login",
  legacyDealerInventory: "/dealer/inventory",
};

export const getDealerPortalPath = (path: string) => {
  if (typeof window === "undefined") return path;

  const host = window.location.hostname.toLowerCase();
  const isLocalPreviewHost = host === "localhost" || host === "127.0.0.1";
  const isLocalDealerPreview =
    isLocalPreviewHost && window.location.pathname.startsWith("/dealer");

  return isLocalDealerPreview ? `/dealer${path}` : path;
};
